import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.quality');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU, getAdminT } from "src/libs/portal/korslovo/i18n";

@Component({
    selector: 'wiz-page-admin-quality',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.quality/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: auto;
}`],
})
export class PageAdminQualityComponent implements OnInit, OnDestroy {
    public ru = RU;
    public t: any = RU;
    public loading: boolean = true;
    public summary: any = null;
    public categories: any[] = [];
    public categoriesLoading: boolean = false;

    // Expanded category → lesson detail
    public expandedCategory: string = '';
    public lessonDetail: any[] = [];
    public lessonLoading: boolean = false;

    // Missing fields section
    public missingWords: any[] = [];
    public missingLoading: boolean = false;
    public missingCategoryFilter: string = '';
    public missingFieldFilter: string = '';
    public showMissing: boolean = false;
    private langListener: any;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.t = getAdminT();
        this.langListener = async () => { this.t = getAdminT(); await this.service.render(); };
        window.addEventListener('admin-lang-change', this.langListener);
        await this.loadSummary();
        await this.loadCategories();
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.langListener) window.removeEventListener('admin-lang-change', this.langListener);
    }

    public async loadSummary() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call("summary");
        if (code === 200) {
            this.summary = data;
        }
        this.loading = false;
        await this.service.render();
    }

    public async loadCategories() {
        this.categoriesLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call("category_detail");
        if (code === 200) {
            this.categories = data || [];
        }
        this.categoriesLoading = false;
        await this.service.render();
    }

    public async toggleCategory(catId: string) {
        if (this.expandedCategory === catId) {
            this.expandedCategory = '';
            this.lessonDetail = [];
            await this.service.render();
            return;
        }
        this.expandedCategory = catId;
        this.lessonLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call("lesson_detail", { category_id: catId });
        if (code === 200) {
            this.lessonDetail = data || [];
        }
        this.lessonLoading = false;
        await this.service.render();
    }

    public async loadMissingFields() {
        this.missingLoading = true;
        this.showMissing = true;
        await this.service.render();
        const params: any = {};
        if (this.missingCategoryFilter) params.category_id = this.missingCategoryFilter;
        if (this.missingFieldFilter) params.field_type = this.missingFieldFilter;
        const { code, data } = await wiz.call("missing_fields", params);
        if (code === 200) {
            this.missingWords = data || [];
        }
        this.missingLoading = false;
        await this.service.render();
    }

    public async onMissingFilterChange() {
        await this.loadMissingFields();
    }

    public goToWords(lessonId: string) {
        this.service.href('/admin/words');
    }

    public coverageColor(pct: number): string {
        if (pct >= 90) return 'text-emerald-700';
        if (pct >= 70) return 'text-amber-700';
        return 'text-red-700';
    }

    public coverageBg(pct: number): string {
        if (pct >= 90) return 'bg-emerald-500';
        if (pct >= 70) return 'bg-amber-500';
        return 'bg-red-500';
    }

    public coverageCardBg(pct: number): string {
        if (pct >= 90) return 'bg-emerald-50 border-emerald-200';
        if (pct >= 70) return 'bg-amber-50 border-amber-200';
        return 'bg-red-50 border-red-200';
    }

    public missingBadge(field: string): string {
        const map: any = {
            description: 'text-purple-700 bg-purple-50 ring-purple-600/20',
            answers: 'text-blue-700 bg-blue-50 ring-blue-600/20',
            audio: 'text-amber-700 bg-amber-50 ring-amber-600/20',
        };
        return map[field] || 'text-gray-700 bg-gray-50 ring-gray-600/20';
    }

    public missingLabel(field: string): string {
        const map: any = { description: 'Описание', answers: 'Допуст. ответы', audio: 'Аудио' };
        return map[field] || field;
    }
}

export default PageAdminQualityComponent;